import Styled from 'styled-components'

export default Styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 -0.5rem;

  & > * {
    margin: 0 0.5rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/DialogButtons/index.js